module.exports = __webpack_public_path__ + "static/media/play_connect.68a6e612.svg";